import styled, { css, keyframes } from "styled-components";

export const TimerPrizeAndNoticeWrapper = styled.div`
  max-width: 736px;
  height: 781px;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  > img {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const Timer1NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 0;
  box-sizing: border-box;
  gap: 20px;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .value {
    background: #363636;
    border-radius: 15.04px;
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
    height: 600px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    word-break: break-all;
    text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
    overflow-wrap: break-word;
    overflow: hidden; /* 내용이 넘치면 잘림 */
    display: -webkit-box; /* 웹킷 박스 모델로 설정 */
    -webkit-line-clamp: 15; /* 15줄로 제한 */
    -webkit-box-orient: vertical; /* 블록 방향 설정 */
  }
`;

export const TimerPrizeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 30px;
    margin-left: 30px;
  }
`;

export const TimerPrizeListWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0 30px;
  width: calc(100% - 60px);
`;

export const TimerPrizeItemTop3 = styled.div<{
  isTop3: boolean;
  subPrizeFont: number;
}>`
  padding: ${({ isTop3 }) => (isTop3 === true ? "17px 20px" : "6px 20px")};
  width: calc(100% - 40px);
  border-radius: 15.04px;
  ${({ isTop3 }) => isTop3 === true && "  background: #303030;"}

  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  > .rank {
    font-family: Pretendard;
    font-size: 30px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    color: #bdbdbd;
  }

  > .rank.high {
    background: linear-gradient(
      95deg,
      #d9ff00 0.13%,
      #fff 18.47%,
      #4bf95f 43.3%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  > .prize-box {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    > .prize {
      padding: 8px 15px;
      color: ${({ isTop3 }) => (isTop3 === true ? "white" : "#BDBDBD")};
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-variant-numeric: tabular-nums;

      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }

    > .sub-prize {
      padding: 6px 15px;
      border-radius: 10px;
      background: linear-gradient(
        103deg,
        #6c36d6 -22.02%,
        #955fff 54.56%,
        #ccb2ff 102.58%
      );
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: ${({ subPrizeFont }) => (subPrizeFont ? subPrizeFont : 20)}px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-40%);
    opacity: 0;
  }
`;

export const TimerPrizeItem = styled.div<{
  length: number;
  subPrizeFont: number;
}>`
  padding: 6px 20px;
  width: calc(100% - 40px);
  border-radius: 15.04px;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${({ length }) =>
    length >= 11 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}

  > .rank {
    font-family: Pretendard;
    font-size: 30px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    color: #bdbdbd;
  }

  > .prize-box {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;

    > .prize {
      padding: 8px 15px;
      color: #bdbdbd;
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-variant-numeric: tabular-nums;

      > span {
        font-size: 55px;
        margin-right: 15px;
        letter-spacing: 1px;
      }
    }

    > .sub-prize {
      padding: 6px 15px;
      border-radius: 10px;
      background: linear-gradient(
        103deg,
        #6c36d6 -22.02%,
        #955fff 54.56%,
        #ccb2ff 102.58%
      );
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;
